<div class="command-container">
  <ng-content></ng-content>
  <div class="in-progress blur" [hidden]="state != 'InProgress'">
    <div class="shade">
      <app-loading-indicator></app-loading-indicator>
    </div>
  </div>
</div>

<ng-template #failure>
  <modal (close)="closeModal()">
    <modal-header>
      <h4>Oops!</h4>
    </modal-header>
    <modal-content>
      <app-failure [error]="error"></app-failure>
    </modal-content>
  </modal>
</ng-template>